<!-- 行业应用 -->
<style scoped>
.application {
    width: 100%;
}
.introduceA {
    width: 100%;
    padding: 35px 0;
    background-color: #f7f8f9;
}
.introduceA .introduceAContent {
    display: -webkit-flex;
    display: flex;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    -webkit-justify-content: space-between;
}
.introduceA .introduceAContent .introduceAItem {
    display: inline-flex;
    display: -webkit-inline-flex;
    width: 290px;
    height: 306px;
    align-items: center;
    -webkit-align-items: center;
    background-color: #ffffff;
    border: 1px solid #e5e8ed;
    border-radius: 3px;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceA .introduceAContent .introduceAItem div {
    width: 100%;
}
.introduceA .introduceAContent .introduceAItem:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
    box-shadow: 10px 0 10px #f3f4f7,-10px 0 10px #f3f4f7,0 10px 10px #f3f4f7,0 -10px 10px #f3f4f7;
    -webkit-box-shadow: 10px 0 10px #f3f4f7,-10px 0 10px #f3f4f7,0 10px 10px #f3f4f7,0 -10px 10px #f3f4f7;
}
.introduceA .introduceAContent .introduceAItem img {
    display: block;
    width: 68px;
    margin: 0 auto;
}
.introduceA .introduceAContent .introduceAItem h1 {
    color: #0e0d0d;
    font-size: 22px;
    text-align: center;
    margin-top: 35px;
}
.introduceA .introduceAContent .introduceAItem p {
    padding: 0 48px;
    margin-top: 30px;
    color: #666666;
    font-size: 14px;
    line-height: 24px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}
.introduceB {
    width: 100%;
    padding: 55px 0 10px;
    background-color: #ffffff;
}
.introduceB .introduceBContent {
    width: 1200px;
    margin: 0 auto;
}
.introduceB .introduceBContent ul {
    display: -webkit-flex;
    display: flex;
    width: 100%;
    margin-top: 35px;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
}
.introduceB .introduceBContent ul li {
    display: inline-block;
    width: 375px;
    height: 237px;
    margin-bottom: 25px;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceB .introduceBContent ul li:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
}
.introduceB .introduceBContent ul li img {
    display: block;
    width: 130px;
    height: 82px;
    margin: 0 auto;
}
.introduceB .introduceBContent ul li h2 {
    text-align: center;
    margin-top: 15px;
    color: #000000;
    font-size: 22px;
}
.introduceB .introduceBContent ul li p {
    padding: 0 10px;
    margin-top: 25px;
    color: #000000;
    font-size: 14px;
    line-height: 24px;
}
.introduceC {
    width: 100%;
    padding: 60px 0 45px;
    background-color: #f7f8f9;
}
.introduceC .introduceCContent {
    width: 1200px;
    margin: 30px auto 0;
    font-size: 0;
}
.introduceC .introduceCContent .letNavbox {
    display: inline-block;
    width: 300px;
    border: 1px solid #e5e8ed;
    background-color: #ffffff;
    box-shadow: 5px 0 10px #e5e8ed,-5px 0 10px #e5e8ed,0 5px 10px #e5e8ed,0 -5px 10px #e5e8ed;
    -webkit-box-shadow: 5px 0 10px #e5e8ed,-5px 0 10px #e5e8ed,0 5px 10px #e5e8ed,0 -5px 10px #e5e8ed;
    vertical-align: top;
}
.introduceC .introduceCContent .letNavbox ul {
    width: 100%;
}
.introduceC .introduceCContent .letNavbox ul li {
    position: relative;
    display: block;
    width: 100%;
    height: 120px;
    padding: 20px 80px 0 18px;
    border-bottom: 1px solid #e5e8ed;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    cursor: pointer;
}
.introduceC .introduceCContent .letNavbox ul li:last-child {
    border-bottom: 0;
}
.introduceC .introduceCContent .letNavbox ul li:hover {
    box-shadow: 2px 0 10px #d0cdcd,-2px 0 10px #d0cdcd,0 2px 10px #d0cdcd,0 -2px 10px #d0cdcd;
    -webkit-box-shadow: 2px 0 10px #d0cdcd,-2px 0 10px #d0cdcd,0 2px 10px #d0cdcd,0 -2px 10px #d0cdcd;
}
.introduceC .introduceCContent .letNavbox ul li h1 {
    color: #000000;
    font-size: 22px;
}
.introduceC .introduceCContent .letNavbox ul li p {
    margin-top: 10px;
    line-height: 24px;
    color: #666666;
    font-size: 14px;
}
.introduceC .introduceCContent .letNavbox ul li .leftNavIcon {
    position: absolute;
    top: 27px;
    right: 35px;
    display: inline-block;
    width: 38px;
    height: 38px;
    background-image: url(../../assets/images/leftNavIcon.png);
}
.introduceC .introduceCContent .letNavbox ul li.selection {
    background-image: -webkit-linear-gradient(to right, #2b7bff , #04a0f7);
    background-image: -moz-linear-gradient(to right, #2b7bff , #04a0f7);
    background-image: -o-linear-gradient(to right, #2b7bff , #04a0f7);
    background-image: linear-gradient(to right, #2b7bff , #04a0f7);
}
.introduceC .introduceCContent .letNavbox ul li.selection h1,
.introduceC .introduceCContent .letNavbox ul li.selection p {
    color: #ffffff;
}
.introduceC .introduceCContent .letNavbox ul li.selection .leftNavIcon  {
    background-image: url(../../assets/images/leftNavIconSelection.png);
}
.introduceC .introduceCContent .rightContent {
    display: inline-block;
    width: 782px;
    margin-left: 59px;
    vertical-align: top;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceC .introduceCContent .rightContent ul {
    width: 100%;
}
.introduceC .introduceCContent .rightContent ul li {
    display: inline-block;
    width: 215px;
    margin-left: 60px;
    animation: dontSelectionPlay .2s forwards;
    -webkit-animation: dontSelectionPlay .2s forwards;
}
.introduceC .introduceCContent .rightContent ul li:first-child {
    margin-left: 0;
}
.introduceC .introduceCContent .rightContent ul li p {
    color: #666666;
    text-align: center;
    font-size: 18px;
}
.introduceC .introduceCContent .rightContent ul li .imgBox {
    width: 100%;
    margin-top: 15px;
}
.introduceC .introduceCContent .rightContent ul li .imgBox video {
    width: 100%;
}
.introduceC .introduceCContent .rightContent ul li:hover {
    animation: selectionPlay .2s forwards;
    -webkit-animation: selectionPlay .2s forwards;
}
video::-webkit-media-controls-enclosure {
    overflow: hidden;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    padding-left: 50px;
    width: calc(100% + 100px);
}
video::-webkit-media-controls-timeline {
    width: 70%;
}
</style>
<template>
    <div class="application">
        <banner></banner>
        <div class="introduceA">
            <div class="introduceAContent">
                <div class="introduceAItem">
                    <div>
                        <img src="@/assets/images/introduceAIcon1.png" />
                        <h1>新连接</h1>
                        <p>不同于传统短信、OTT，5G消息赋予了行业客户与用户之间的新的连接渠道</p>
                    </div>
                </div>
                <div class="introduceAItem">
                    <div>
                        <img src="@/assets/images/introduceAIcon2.png" />
                        <h1>新服务</h1>
                        <p>5G消息赋予客户服务更加智能化，便捷化的服务体验，同时促进传统客户服务方式升级</p>
                    </div>
                </div>
                <div class="introduceAItem">
                    <div>
                        <img src="@/assets/images/introduceAIcon3.png" />
                        <h1>新营销</h1>
                        <p>基于数据智能推荐及个性化营销手段，更精准、更高效触达用户群，拓展企业新营销模式</p>
                    </div>
                </div>
                <div class="introduceAItem">
                    <div>
                        <img src="@/assets/images/introduceAIcon4.png" />
                        <h1>新模式</h1>
                        <p>基于5G消息能够有效降低开发成本、运营成本、时间成本</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="introduceB">
            <div class="introduceBContent">
                <modularTit :titleName="'行业价值'"></modularTit>
                <ul>
                    <li>
                        <img src="@/assets/images/introduceBIcon1.png" />
                        <h2>新渠道/新生态</h2>
                        <p>全新连接用户的渠道方式，全新的5G消息生态可以带来更丰富、更便捷的行业应用场景，从而实现更多客户价值</p>
                    </li>
                    <li>
                        <img src="@/assets/images/introduceBIcon2.png" />
                        <h2>100%用户到达</h2>
                        <p>不同于APP、微信公众号，5G消息用户触达范围更广，用户无需下载安装、无需关注即可使用，三网消息100%覆盖</p>
                    </li>
                    <li>
                        <img src="@/assets/images/introduceBIcon3.png" />
                        <h2>权威认证、品牌形象</h2>
                        <p>运营商官方审核认证的5G消息入口，更具权威性。企业名称+logo+企业统一消息端口号展示+认证告知，5G消息企业品牌展示更友好</p>
                    </li>
                    <li>
                        <img src="@/assets/images/introduceBIcon4.png" />
                        <h2>低门槛，符合用户习惯</h2>
                        <p>5G新消息基于消息机制的交互方式符合OTT、短信用户使用习惯，低门槛的使用方式意味者行业客户无需额外投入客户培育</p>
                    </li>
                    <li>
                        <img src="@/assets/images/introduceBIcon5.png" />
                        <h2>实名制、免注册</h2>
                        <p>运营商通过SIM卡放号，拥有所有用户的实名信息，以及非常成熟的认证流程，可用于各种高安全性的业务</p>
                    </li>
                    <li></li>
                </ul>
            </div>
        </div>
        <div class="introduceC">
            <div class="introduceCContent">
                <modularTit :titleName="'行业案例'"></modularTit>
                <div class="introduceCContent">
                    <div class="letNavbox">
                        <ul>
                            <li 
                                v-for="(item,index) in introduceCNavList" 
                                :key="index" 
                                :class="{'selection': introduceCNavS === index}" 
                                @click="switchIntroduceCNav(index)">
                                <h1>{{item.title}}</h1>
                                <p v-html="item.tips"></p>
                                <i class="leftNavIcon"></i>
                            </li>
                        </ul>
                    </div>
                    <div class="rightContent">
                        <ul v-show="introduceCNavS === 0">
                            <li>
                                <p>银行卡激活</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case1A.mp4" controls="controls"></video>
                                </div>
                            </li>
                            <li>
                                <p>信用卡还款</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case1B.mp4" controls="controls"></video>
                                </div>
                            </li>
                            <li>
                                <p>动账提醒</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case1C.mp4" controls="controls"></video>
                                </div>
                            </li>
                        </ul>
                        <ul v-show="introduceCNavS === 1">
                            <li>
                                <p>优惠券领取</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case2A.mp4" controls="controls"></video>
                                </div>
                            </li>
                            <li>
                                <p>物流查询</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case2B.mp4" controls="controls"></video>
                                </div>
                            </li>
                            <!-- <li>
                                <p>订单查询</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case2C.mp4" controls="controls"></video>
                                </div>
                            </li> -->
                        </ul>
                        <ul v-show="introduceCNavS === 2">
                            <li>
                                <p>机票预订</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case3A.mp4" controls="controls"></video>
                                </div>
                            </li>
                            <li>
                                <p>航班延误提醒</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case3B.mp4" controls="controls"></video>
                                </div>
                            </li>
                            <li>
                                <p>航班到达提醒</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case3C.mp4" controls="controls"></video>
                                </div>
                            </li>
                        </ul>
                        <ul v-show="introduceCNavS === 3">
                            <li>
                                <p>宣传教育</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case4A.mp4" controls="controls"></video>
                                </div>
                            </li>
                            <li>
                                <p>群众举报</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case4B.mp4" controls="controls"></video>
                                </div>
                            </li>
                        </ul>
                        <ul v-show="introduceCNavS === 4">
                            <li>
                                <p>月底电费账单</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case5A.mp4" controls="controls"></video>
                                </div>
                            </li>
                            <li>
                                <p>缴纳电费</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case5B.mp4" controls="controls"></video>
                                </div>
                            </li>
                            <li>
                                <p>故障提醒</p>
                                <div class="imgBox">
                                    <video src="@/assets/images/case5C.mp4" controls="controls"></video>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <introduce></introduce>
    </div>
</template>
<script>
import banner from '@/components/banner'
import modularTit from '@/components/modularTit'
import introduce from "@/components/introduce.vue"
export default {
    name: 'application',
    components: {
        modularTit,
        banner,
        introduce
    },
    data () {
        return {
            introduceCNavS: 0,
            introduceCNavList: [
                {
                    title: '金融',
                    tips: '消息通知｜信息查询<br />自助业务办理｜客服服务'
                },
                {
                    title: '电商',
                    tips: '营销服务｜服务消息通知<br />自助业务办理｜客服服务'
                },
                {
                    title: '交通',
                    tips: '消息通知｜信息查询<br />自助业务办理｜客服服务'
                },
                {
                    title: '政务',
                    tips: '消息通知｜信息查询<br />自助业务办理｜客服服务'
                },
                {
                    title: '电力',
                    tips: '消息通知｜信息查询<br />自助业务办理｜客服服务'
                }
            ]
        }
    },
    methods: {
        switchIntroduceCNav(index) {
            this.introduceCNavS = index;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/application/index.vue